module.exports = __webpack_public_path__ + "static/media/11.a93288a0.png";